export enum OfferOrderFormTypeEnum {
  Create,
  Edit,
  Correct
}
